import React from 'react';
import { Space, Typography } from 'antd';
import type { Transaction } from '../../services/billingAdminService';

const { Text } = Typography;

interface TransactionAmountProps {
  record: Transaction;
}

/**
 * Amount cell for the billing transaction tables. Amount is what the customer
 * paid; a wallet top-up also shows the credit it gave, which can be higher
 * (tier bonus). Older top-ups never stored the paid amount, so that is shown
 * as not recorded rather than passing the credit off as the payment.
 */
const TransactionAmount: React.FC<TransactionAmountProps> = ({ record }) => {
  const isRefund = record.Type === 'refund';
  const isTopup = record.Type === 'topup';
  const paidUnknown = isTopup && record.PaidAmountRecorded === false;

  return (
    <Space direction="vertical" size={0}>
      {paidUnknown ? (
        <Text type="secondary">Paid: not recorded</Text>
      ) : (
        <Text strong style={{ color: isRefund ? '#cf1322' : '#3f8600' }}>
          {isRefund ? '-' : ''}${record.Amount.toFixed(2)} {record.Currency}
        </Text>
      )}
      {isTopup && record.CreditAmount != null && (
        <Text type="secondary" style={{ fontSize: '12px' }}>
          Credit ${record.CreditAmount.toFixed(2)}
        </Text>
      )}
    </Space>
  );
};

export default TransactionAmount;
